// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   DialogContentText,
//   TextField,
//   Button,
//   Input,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   IconButton,
// } from '@mui/material';
// import './PackagePage.css';
// import { useMain } from '../../hooks/useMain';

// import TextInputs from 'src/components/inputs/TextInputs';
// import { GrStar } from 'react-icons/gr';
// import { ButtonToggle } from 'reactstrap';
// import SearchImg from '../../../assets/search.svg';
// import { Grid } from 'rsuite';
// import { Box, display } from '@mui/system';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { MdClear } from "react-icons/md";
// import { number } from 'prop-types';

// const PackagePage = () => {
//   const { activeBranchId, getAllService, setShowMessage, createPackages } = useMain();
//   const [services, setServices] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [packages, setPackages] = useState([]);
//   const [showPackageCard, setShowPackageCard] = useState(false);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [search, setSearch] = useState('');
//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(1);
//   const [clear, setClear] = useState(false);
//   const [filterData, setFilterData] = useState([]);
//   const [packageDetails, setPackageDetails] = useState({
//     packageName: '',
//     packageDuration: '',
//     totalAmount: 0,
//   });
//   const [loading, setLoader] = useState(false);

//   useEffect(() => {
//     applyFilters(services, limit, page, search);
//   }, [services, limit, page, search]);

//   const clearDataHandler = () => {
//     setLimit(10);
//     setPage(1);
//     setSearch('');
//     if (clear) {
//       getAllServicefData('clear');
//       setServices('clear');
//       setClear(false);
//     }
//   };

//   const getAllServicefData = async () => {
//     try {
//       const res = await getAllService(activeBranchId);
//       setServices(res?.data || []);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getAllServicefData();
//     }
//     return () => {
//       setServices([]);
//     };
//   }, [activeBranchId]);

//   const handleCheckboxChange = (service) => {
//     setSelectedServices((prevSelected) => {
//       const isSelected = prevSelected.some((item) => item.service._id === service._id);
//       if (isSelected) {
//         return prevSelected.filter((item) => item.service._id !== service._id);
//       } else {
//         return [...prevSelected, { service }];
//       }
//     });
//   };

//   // const handlePackageDetailsChange = (e) => {
//   //   const { name, value } = e.target;

//   //   // Explicitly convert the value to a number if it's a 'packageDuration' field
//   //   const newValue = name === 'packageDuration' ? Number(value) : value;

//   //   setPackageDetails((prevDetails) => ({
//   //     ...prevDetails,
//   //     [name]: newValue,
//   //   }));
//   // };
//   const handlePackageDetailsChange = (e) => {
//     const { name, value } = e.target;


//     let newValue = value;
//     if (name === 'packageDuration') {
//       newValue = value === '' ? '' : Number(value);
//     }

//     setPackageDetails((prevDetails) => ({
//       ...prevDetails,
//       [name]: newValue,
//     }));
//   };


//   const recalculateTotalAmount = (updatedServices) => {
//     const totalAmount = updatedServices.reduce((total, item) => total + item.service.price || 0, 0);
//     setPackageDetails((prevDetails) => ({
//       ...prevDetails,
//       totalAmount,
//     }));
//   };

//   const calculateTotalSelectedPrice = () => {
//     return selectedServices.reduce((total, item) => total + (item.service.price || 0), 0);
//   };

//   const handleOpenDialog = () => {
//     setShowPackageCard(true);
//     setOpenDialog(true);
//     recalculateTotalAmount(selectedServices);
//     setPackages([selectedServices]);
//     setSelectedServices([]);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setPackages([]);
//     setPackageDetails({
//       packageName: '',
//       packageDuration: 0,
//       totalAmount: 0,
//     });
//   };

//   const handleSubmitPackage = async () => {
//     const packageData = {
//       packageName: packageDetails.packageName,
//       price: packageDetails.totalAmount,
//       services: packages[0].map((item) => item.service._id),
//       packageDuration: packageDetails.packageDuration,
//       branchDetails: activeBranchId,
//     };
//     //console.log(packageData, "packageDataaaaaaaaaaa");

//     try {
//       setLoader(true);
//       const res = await createPackages(
//         JSON.stringify({
//           ...packageData,
//         }),
//       );

//       handleCloseDialog();
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Package created successfully',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({ message: res.message || 'Package not created', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Error creating Packages',
//         messageType: 'error',
//       });
//     } finally {
//       setLoader(false);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       setClear(true);
//       getAllServicefData();
//     }
//     return () => {
//       setServices([]);
//     };
//   }, [activeBranchId, limit, page]);

//   const handleLimitChange = (e) => {
//     setLimit(e.target.value);
//     setPage(1);
//   };

//   // const applyFilters = (services, limit, page, searchName) => {
//   //   let filteredData = services.filter((item) => {
//   //     let isNameMatch = true;
//   //     if (searchName) {
//   //       isNameMatch =
//   //         item.serviceName.toLowerCase().includes(searchName.toLowerCase()) ||
//   //         item.serviceName.includes(searchName);
//   //     }
//   //     return isNameMatch;
//   //   });

//   //   // Applying pagination
//   //   const startIndex = (page - 1) * limit;
//   //   const endIndex = startIndex + limit;
//   //   filteredData = filteredData.slice(startIndex, endIndex);
//   //   setFilterData(filteredData);
//   // };


//   const applyFilters = (services, limit, page, searchName) => {
//     let filteredData = services.filter((item) => {
//       return item.serviceName.toLowerCase().includes(searchName.toLowerCase());
//     });

//     // Set the filtered data for rendering
//     setFilterData(filteredData);
//     // Pagination logic
//     const startIndex = (page - 1) * limit;
//     const endIndex = startIndex + limit;
//     filteredData = filteredData.slice(startIndex, endIndex);
//     setFilterData(filteredData);
//   };

//   // Reset page when search input changes
//   useEffect(() => {
//     setPage(1);
//   }, [search]);

//   // Adjust pagination count based on filtered data
//   const paginationCount = Math.ceil(services.filter((item) =>
//     item.serviceName.toLowerCase().includes(search.toLowerCase())
//   ).length / limit);


//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   const handleClearSelectedServices = () => {
//     setSearch('');
//     setLimit(10); // Reset limit to default
//     setPage(1);
//     setSelectedServices([]);
//   };

//   return (
//     <PageContainer title="Package" description="this contains all packages">
//       <DashboardCard2 title="Packages">
//         {/* <DashboardCard2 > */}
//         <div className="package-container" style={{ display: 'flex', gap: '20px' }}>
//           <div style={{ flex: 3 }}>
//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 padding: '1rem',
//                 marginTop: '-3rem',
//                 // marginLeft: '-20rem',
//                 marginLeft: '-35rem'
//               }}
//             >
//               <div>
//                 {/* <h2>Packages</h2> */}
//               </div>
//               <div>
//                 <Grid item xs={2} style={{ marginLeft: '-1rem' }} >
//                   <InputLabel>Show per page</InputLabel>
//                   <Select
//                     style={{
//                       borderRadius: '7px',
//                       border: '0.5px solid #6174DD',
//                       padding: '4px 12px',
//                       background: '#FFF',
//                       height: '40px',
//                     }}
//                     value={limit}
//                     onChange={handleLimitChange}
//                   >
//                     <MenuItem value={10}>10</MenuItem>
//                     <MenuItem value={20}>20</MenuItem>
//                     <MenuItem value={50}>50</MenuItem>
//                   </Select>
//                 </Grid>
//               </div>
//               <div className="search-input" style={{ width: '10rem', marginTop: '1.6rem', marginRight: '-1rem' }}>
//                 <img src={SearchImg} alt="" />
//                 <input
//                   type="text"
//                   placeholder="Search"
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                 />
//                 {search && (
//                   <IconButton
//                     onClick={() => {
//                       setSearch('');
//                       // Additional clear logic if necessary
//                     }}
//                     style={{ padding: 1 }}
//                   >
//                     <MdClear style={{
//                       color: '#000',
//                       marginRight: '-0.2rem', marginTop: '0.1rem',
//                       fontSize: '1.1rem'
//                     }} />
//                   </IconButton>
//                 )}
//               </div>
//               {/* <Button
//                 variant="contained"
//                 color="primary"
//                 sx={{
//                   height: '40px',
//                   // width: '100%',
//                   background: '#ff4d4d',
//                   marginBottom: '0.3rem',
//                   marginTop: '1.8rem',
//                   '&:hover': { background: '#ff6666' },
//                 }}
//                 onClick={handleClearSelectedServices}
//               >
//                 Clear
//               </Button> */}
//             </div>
//             <table className="table-container mt-3">
//               <thead className="table-thead">
//                 <tr>
//                   {['S.no', 'Service name', 'Category', 'Service For', 'Price', 'Select'].map(
//                     (h, index) => (
//                       <th key={index} style={{ width: '100%' }}>
//                         {h}
//                       </th>
//                     ),
//                   )}
//                 </tr>
//               </thead>
//               <tbody className="table-tbody">
//                 {filterData.length > 0 ? (
//                   filterData.map((item, index) => {
//                     const isSelected = selectedServices.some(
//                       (service) => service.service._id === item._id,
//                     );
//                     return (
//                       <tr key={item._id} className={isSelected ? 'selected' : ''} style={{ backgroundColor: isSelected ? '#f0f8ff' : '#fff' }}>
//                         <td style={{ width: '100%' }}>{index + 1 + (page - 1) * limit}</td>
//                         <td style={{ width: '100%' }}>{item?.serviceName}</td>
//                         <td style={{ width: '100%' }}>{item?.category}</td>
//                         <td style={{ width: '100%' }}>{item?.serviceFor}</td>
//                         <td style={{ width: '100%' }}>₹ {item?.price}</td>
//                         <td style={{ width: '100%' }}>
//                           <input
//                             type="checkbox"
//                             checked={isSelected}
//                             style={{ cursor: 'pointer', width: '15px', height: '15px', marginLeft: '0.2rem' }}
//                             onChange={() => handleCheckboxChange(item)}
//                           />
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
//                       No data found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//             {/* <Pagination
//               style={{ display: 'flex', alignItems: 'end', justifyContent: "flex-end" }}
//               // count={Math.ceil(services.length / limit)}
//               count={paginationCount}
//               page={page}
//               onChange={(e, value) => setPage(value)}
//             /> */}
//             {filterData.length > 0 && (
//               <Pagination
//                 style={{ display: 'flex', alignItems: 'end', justifyContent: "flex-end" }}
//                 count={paginationCount}
//                 page={page}
//                 onChange={(e, value) => setPage(value)}
//               />
//             )}
//           </div>

//           <div style={{ flex: 0.9, marginTop: '70px', marginLeft: '25px' }}>
//             <h3>Selected Services</h3>
//             {selectedServices.length > 0 ? (
//               <ul>
//                 {selectedServices.map((item, index) => (
//                   <li key={index}>
//                     {item.service.serviceName} - ₹{item.service.price}
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p>No services selected</p>
//             )}
//             {selectedServices.length > 0 && (
//               <div>
//                 <h5>Total Price: ₹{calculateTotalSelectedPrice()}</h5>
//               </div>
//             )}
//             <div>
//               <button className="create-btn" onClick={handleOpenDialog}>
//                 Create Package
//               </button>
//             </div>
//           </div>

//           {showPackageCard && packages.length > 0 && (
//             <Dialog
//               open={openDialog}
//               onClose={handleCloseDialog}
//               // fullWidtzh='md'
//               // fullWidth='cm'
//               PaperProps={{
//                 style: {
//                   width: '500px', // set your custom width here
//                 },
//               }}
//             >
//               <DialogTitle>Package Details</DialogTitle>
//               {packages.map((packageItems, packageIndex) => (
//                 <DialogContent key={packageIndex} className="dialog-content">
//                   <DialogContentText>Here you can add Package</DialogContentText>
//                   <div className="packagebox" style={{ display: 'flex', gap: '16px' }}>
//                     <div style={{ flex: 1 }}>
//                       <label>
//                         Package Name
//                         <GrStar
//                           style={{
//                             color: '#FF0000',
//                             fontSize: '7.7px',
//                             marginBottom: '10px',
//                             marginLeft: '2px',
//                             fontWeight: '900',
//                           }}
//                         />
//                       </label>
//                       <TextField
//                         autoFocus
//                         margin="dense"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         name="packageName"
//                         placeholder={'Package Name'}
//                         value={packageDetails.packageName}
//                         onChange={handlePackageDetailsChange}
//                       />
//                     </div>
//                   </div>

//                   <div style={{ width: '100%' }}>
//                     {/* <div className='heading-h6' style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <h6>Services</h6>
//                                     <h6>Price</h6>
//                                 </div> */}

//                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                       <thead>
//                         <tr>
//                           <th
//                             style={{
//                               border: '1px solid #D3D3D3',
//                               padding: '8px',
//                               fontWeight: 'bolder',
//                             }}
//                           >
//                             Service
//                           </th>
//                           <th
//                             style={{
//                               border: '1px solid #D3D3D3',
//                               padding: '8px',
//                               fontWeight: 'bolder',
//                             }}
//                           >
//                             Price
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {packageItems.map((item, index) => (
//                           <tr key={index}>
//                             <td style={{ border: '1px solid #D3D3D3', padding: '8px' }}>
//                               {item.service.serviceName}
//                             </td>
//                             <td style={{ border: '1px solid #D3D3D3', padding: '8px' }}>
//                               {item.service.price}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>

//                   <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
//                     {/* <div style={{ width: '100%' }}>
//                       <TextInputs
//                         title={'Duration (in Months)'}
//                         placeholder={'0'}
//                         name={'packageDuration'}
//                         value={packageDetails?.packageDuration}
//                         handleChange={handlePackageDetailsChange}
//                         type={'number'}
//                         min={'0'}
//                       />
//                     </div> */}
//                     <div style={{ width: '100%' }}>
//                       <TextInputs
//                         title={'Duration (in Months)'}
//                         placeholder={'Enter duration'}
//                         name={'packageDuration'}
//                         value={packageDetails.packageDuration === '' ? '' : packageDetails.packageDuration}
//                         handleChange={handlePackageDetailsChange}
//                         type={'number'}
//                         min={'0'}
//                       />
//                     </div>
//                   </div>

//                   <div style={{ width: '100%', marginTop: '20px' }}>
//                     <label>
//                       Package amount
//                       <GrStar
//                         style={{
//                           color: '#FF0000',
//                           fontSize: '7.7px',
//                           marginBottom: '10px',
//                           marginLeft: '2px',
//                           fontWeight: '900',
//                         }}
//                       />
//                     </label>
//                     <Input
//                       margin="dense"
//                       type="number"
//                       fullWidth
//                       variant="outlined"
//                       name="totalAmount"
//                       value={packageDetails.totalAmount}
//                       onChange={handlePackageDetailsChange}
//                     />
//                     <DialogActions>
//                       <ButtonToggle onClick={handleCloseDialog} color="primary">
//                         Cancel
//                       </ButtonToggle>
//                       <ButtonToggle onClick={handleSubmitPackage} color="primary">
//                         Create
//                       </ButtonToggle>
//                     </DialogActions>
//                   </div>
//                 </DialogContent>
//               ))}
//             </Dialog>
//           )}
//         </div>
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default PackagePage;

//new code with card 
// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   DialogContentText,
//   TextField,
//   Button,
//   Input,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   IconButton,
//   Chip,
//   FormControl,
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Checkbox,
//   FormControlLabel
// } from '@mui/material';
// import './PackagePage.css';
// import { useMain } from '../../hooks/useMain';

// import TextInputs from 'src/components/inputs/TextInputs';
// import { GrStar } from 'react-icons/gr';
// import { ButtonToggle } from 'reactstrap';
// import SearchImg from '../../../assets/search.svg';
// import { Grid } from 'rsuite';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { MdClear, MdCategory, MdSpa, MdAttachMoney, MdAccessTime } from "react-icons/md";
// import { FaFemale, FaMale } from "react-icons/fa";

// const PackagePage = () => {
//   const { activeBranchId, getAllService, setShowMessage, createPackages } = useMain();
//   const [services, setServices] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [packages, setPackages] = useState([]);
//   const [showPackageCard, setShowPackageCard] = useState(false);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [search, setSearch] = useState('');
//   const [limit, setLimit] = useState(8);
//   const [page, setPage] = useState(1);
//   const [clear, setClear] = useState(false);
//   const [filterData, setFilterData] = useState([]);
//   const [packageDetails, setPackageDetails] = useState({
//     packageName: '',
//     packageDuration: '',
//     totalAmount: 0,
//   });
//   const [loading, setLoader] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [categories, setCategories] = useState([]);

//   // Extract unique categories
//   useEffect(() => {
//     if (services.length > 0) {
//       const uniqueCategories = [...new Set(services.map(service => service.category))];
//       setCategories(['All', ...uniqueCategories]);
//     }
//   }, [services]);

//   useEffect(() => {
//     applyFilters(services, limit, page, search, selectedCategory);
//   }, [services, limit, page, search, selectedCategory]);

//   const clearDataHandler = () => {
//     setLimit(8);
//     setPage(1);
//     setSearch('');
//     setSelectedCategory('All');
//     if (clear) {
//       getAllServicefData('clear');
//       setServices('clear');
//       setClear(false);
//     }
//   };

//   const getAllServicefData = async () => {
//     try {
//       const res = await getAllService(activeBranchId);
//       setServices(res?.data || []);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getAllServicefData();
//     }
//     return () => {
//       setServices([]);
//     };
//   }, [activeBranchId]);

//   const handleCheckboxChange = (service) => {
//     setSelectedServices((prevSelected) => {
//       const isSelected = prevSelected.some((item) => item.service._id === service._id);
//       if (isSelected) {
//         return prevSelected.filter((item) => item.service._id !== service._id);
//       } else {
//         return [...prevSelected, { service }];
//       }
//     });
//   };

//   const handlePackageDetailsChange = (e) => {
//     const { name, value } = e.target;

//     let newValue = value;
//     if (name === 'packageDuration') {
//       newValue = value === '' ? '' : Number(value);
//     }

//     setPackageDetails((prevDetails) => ({
//       ...prevDetails,
//       [name]: newValue,
//     }));
//   };

//   const recalculateTotalAmount = (updatedServices) => {
//     const totalAmount = updatedServices.reduce((total, item) => total + item.service.price || 0, 0);
//     setPackageDetails((prevDetails) => ({
//       ...prevDetails,
//       totalAmount,
//     }));
//   };

//   const calculateTotalSelectedPrice = () => {
//     return selectedServices.reduce((total, item) => total + (item.service.price || 0), 0);
//   };

//   const handleOpenDialog = () => {
//     setShowPackageCard(true);
//     setOpenDialog(true);
//     recalculateTotalAmount(selectedServices);
//     setPackages([selectedServices]);
//     setSelectedServices([]);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setPackages([]);
//     setPackageDetails({
//       packageName: '',
//       packageDuration: 0,
//       totalAmount: 0,
//     });
//   };

//   const handleSubmitPackage = async () => {
//     const packageData = {
//       packageName: packageDetails.packageName,
//       price: packageDetails.totalAmount,
//       services: packages[0].map((item) => item.service._id),
//       packageDuration: packageDetails.packageDuration,
//       branchDetails: activeBranchId,
//     };

//     try {
//       setLoader(true);
//       const res = await createPackages(
//         JSON.stringify({
//           ...packageData,
//         }),
//       );

//       handleCloseDialog();
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Package created successfully',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({ message: res.message || 'Package not created', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Error creating Packages',
//         messageType: 'error',
//       });
//     } finally {
//       setLoader(false);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       setClear(true);
//       getAllServicefData();
//     }
//     return () => {
//       setServices([]);
//     };
//   }, [activeBranchId, limit, page]);

//   const handleLimitChange = (e) => {
//     setLimit(e.target.value);
//     setPage(1);
//   };

//   const applyFilters = (services, limit, page, searchName, category) => {
//     let filteredData = services.filter((item) => {
//       const nameMatch = item.serviceName.toLowerCase().includes(searchName.toLowerCase());
//       const categoryMatch = category === 'All' || item.category === category;
//       return nameMatch && categoryMatch;
//     });

//     // Set the filtered data for rendering
//     const startIndex = (page - 1) * limit;
//     const endIndex = startIndex + limit;
//     filteredData = filteredData.slice(startIndex, endIndex);
//     setFilterData(filteredData);
//   };

//   // Reset page when search input changes
//   useEffect(() => {
//     setPage(1);
//   }, [search, selectedCategory]);

//   // Adjust pagination count based on filtered data
//   const filteredServices = services.filter((item) => {
//     const nameMatch = item.serviceName.toLowerCase().includes(search.toLowerCase());
//     const categoryMatch = selectedCategory === 'All' || item.category === selectedCategory;
//     return nameMatch && categoryMatch;
//   });

//   const paginationCount = Math.ceil(filteredServices.length / limit);

//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   const handleClearSelectedServices = () => {
//     setSearch('');
//     setSelectedCategory('All');
//     setLimit(8);
//     setPage(1);
//     setSelectedServices([]);
//   };

//   const ServiceCard = ({ service, isSelected, onSelect }) => {
//     return (
//       <Card 
//         className={`service-card ${isSelected ? 'selected' : ''}`}
//         onClick={() => onSelect(service)}
//       >
//         <CardContent>
//           <div className="card-header">
//             <Typography variant="h6" className="service-name">
//               {service.serviceName}
//             </Typography>
//             <Checkbox
//               checked={isSelected}
//               onChange={() => onSelect(service)}
//               color="primary"
//               style={{ padding: 0 }}
//             />
//           </div>

//           <div className="service-details">
//             <div className="service-info">
//               <span className="info-item">
//                 <MdCategory className="info-icon" />
//                 {service.category}
//               </span>
//               <span className="info-item">
//                 <MdAttachMoney className="info-icon" />
//                 ₹{service.price}
//               </span>
//             </div>

//             <div className="service-info">
//               <span className="info-item">
//                 {service.serviceFor === 'Female' ? (
//                   <FaFemale className="info-icon" />
//                 ) : (
//                   <FaMale className="info-icon" />
//                 )}
//                 {service.serviceFor}
//               </span>
//               <span className="info-item duration">
//                 <MdAccessTime className="info-icon" />
//                 {service.duration || '30'} min
//               </span>
//             </div>
//           </div>
//         </CardContent>
//       </Card>
//     );
//   };

//   const SelectedServiceCard = ({ service, onRemove }) => {
//     return (
//       <Card className="selected-service-card">
//         <CardContent>
//           <div className="selected-service-header">
//             <Typography variant="subtitle1" className="selected-service-name">
//               {service.serviceName}
//             </Typography>
//             <IconButton 
//               size="small" 
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onRemove(service);
//               }}
//               className="remove-btn"
//             >
//               <MdClear />
//             </IconButton>
//           </div>
//           <Typography variant="body2" color="textSecondary">
//             {service.category} • {service.serviceFor}
//           </Typography>
//           <Typography variant="body1" className="selected-service-price">
//             ₹{service.price}
//           </Typography>
//         </CardContent>
//       </Card>
//     );
//   };

//   return (
//     <PageContainer title="Package" description="this contains all packages">
//       <DashboardCard2 title="Create Package">
//         <div className="package-container">
//           <div className="services-section">
//             <div className="filters-container">
//               <div className="search-filter">
//                 <div className="search-input">
//                   <img src={SearchImg} alt="Search" />
//                   <input
//                     type="text"
//                     placeholder="Search services..."
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                   />
//                   {search && (
//                     <IconButton
//                       onClick={() => setSearch('')}
//                       size="small"
//                     >
//                       <MdClear />
//                     </IconButton>
//                   )}
//                 </div>

//                 <FormControl variant="outlined" size="small" className="category-filter">
//                   <InputLabel>Category</InputLabel>
//                   <Select
//                     value={selectedCategory}
//                     onChange={(e) => setSelectedCategory(e.target.value)}
//                     label="Category"
//                   >
//                     {categories.map((category, index) => (
//                       <MenuItem key={index} value={category}>
//                         {category}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl variant="outlined" size="small" className="page-size-filter">
//                   <InputLabel>Show</InputLabel>
//                   <Select
//                     value={limit}
//                     onChange={handleLimitChange}
//                     label="Show"
//                   >
//                     <MenuItem value={8}>8</MenuItem>
//                     <MenuItem value={16}>16</MenuItem>
//                     <MenuItem value={24}>24</MenuItem>
//                   </Select>
//                 </FormControl>

//                 <Button 
//                   variant="outlined" 
//                   onClick={handleClearSelectedServices}
//                   className="clear-btn"
//                 >
//                   Clear All
//                 </Button>
//               </div>
//             </div>

//             <div className="services-grid">
//               {filterData.length > 0 ? (
//                 filterData.map((service) => {
//                   const isSelected = selectedServices.some(
//                     (item) => item.service._id === service._id
//                   );
//                   return (
//                     <ServiceCard
//                       key={service._id}
//                       service={service}
//                       isSelected={isSelected}
//                       onSelect={handleCheckboxChange}
//                     />
//                   );
//                 })
//               ) : (
//                 <div className="no-services">
//                   <MdSpa size={48} />
//                   <Typography variant="h6">No services found</Typography>
//                   <Typography variant="body2" color="textSecondary">
//                     Try adjusting your search or filters
//                   </Typography>
//                 </div>
//               )}
//             </div>

//             {filteredServices.length > 0 && (
//               <div className="pagination-container">
//                 <Pagination
//                   count={paginationCount}
//                   page={page}
//                   onChange={(e, value) => setPage(value)}
//                   color="primary"
//                 />
//               </div>
//             )}
//           </div>

//           <div className="selection-section">
//             <Card className="selection-card">
//               <CardContent>
//                 <Typography variant="h6" className="selection-title">
//                   Selected Services
//                 </Typography>

//                 {selectedServices.length > 0 ? (
//                   <>
//                     <div className="selected-services-list">
//                       {selectedServices.map((item, index) => (
//                         <SelectedServiceCard
//                           key={index}
//                           service={item.service}
//                           onRemove={(service) => handleCheckboxChange(service)}
//                         />
//                       ))}
//                     </div>

//                     <div className="selection-summary">
//                       <div className="summary-item">
//                         <Typography variant="body1">Total Services:</Typography>
//                         <Typography variant="body1" className="summary-value">
//                           {selectedServices.length}
//                         </Typography>
//                       </div>
//                       <div className="summary-item total">
//                         <Typography variant="h6">Total Price:</Typography>
//                         <Typography variant="h6" className="summary-value">
//                           ₹{calculateTotalSelectedPrice()}
//                         </Typography>
//                       </div>

//                       <Button
//                         variant="contained"
//                         color="primary"
//                         fullWidth
//                         onClick={handleOpenDialog}
//                         className="create-package-btn"
//                         disabled={selectedServices.length === 0}
//                       >
//                         Create Package
//                       </Button>
//                     </div>
//                   </>
//                 ) : (
//                   <div className="empty-selection">
//                     <MdSpa size={32} />
//                     <Typography variant="body2" color="textSecondary">
//                       Select services from the list to create a package
//                     </Typography>
//                   </div>
//                 )}
//               </CardContent>
//             </Card>
//           </div>
//         </div>

//         {showPackageCard && packages.length > 0 && (
//           <Dialog
//             open={openDialog}
//             onClose={handleCloseDialog}
//             maxWidth="sm"
//             fullWidth
//           >
//             <DialogTitle className="dialog-title">
//               <Typography variant="h5">Create New Package</Typography>
//             </DialogTitle>

//             {packages.map((packageItems, packageIndex) => (
//               <DialogContent key={packageIndex} className="dialog-content">
//                 <DialogContentText className="dialog-subtitle">
//                   Review and finalize your package details
//                 </DialogContentText>

//                 <div className="package-form">
//                   <TextField
//                     autoFocus
//                     margin="dense"
//                     label="Package Name"
//                     type="text"
//                     fullWidth
//                     variant="outlined"
//                     name="packageName"
//                     placeholder="e.g., Premium Facial Package"
//                     value={packageDetails.packageName}
//                     onChange={handlePackageDetailsChange}
//                     required
//                     InputProps={{
//                       endAdornment: <GrStar style={{ color: '#FF0000', fontSize: '10px' }} />
//                     }}
//                   />

//                   <div className="services-table">
//                     <Typography variant="subtitle1" className="table-title">
//                       Included Services
//                     </Typography>
//                     <div className="table-container">
//                       {packageItems.map((item, index) => (
//                         <div key={index} className="service-row">
//                           <div className="service-name">
//                             <MdSpa className="service-icon" />
//                             <span>{item.service.serviceName}</span>
//                           </div>
//                           <div className="service-price">₹{item.service.price}</div>
//                         </div>
//                       ))}
//                     </div>

//                     <div className="table-footer">
//                       <div className="total-row">
//                         <span>Subtotal:</span>
//                         <span>₹{packageDetails.totalAmount}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="form-row">
//                     <TextField
//                       margin="dense"
//                       label="Duration (months)"
//                       type="number"
//                       fullWidth
//                       variant="outlined"
//                       name="packageDuration"
//                       placeholder="Enter duration in months"
//                       value={packageDetails.packageDuration}
//                       onChange={handlePackageDetailsChange}
//                       inputProps={{ min: 0 }}
//                     />

//                     <TextField
//                       margin="dense"
//                       label="Package Amount"
//                       type="number"
//                       fullWidth
//                       variant="outlined"
//                       name="totalAmount"
//                       value={packageDetails.totalAmount}
//                       onChange={handlePackageDetailsChange}
//                       InputProps={{
//                         startAdornment: <span style={{ marginRight: 8 }}>₹</span>,
//                         endAdornment: <GrStar style={{ color: '#FF0000', fontSize: '10px' }} />
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <DialogActions className="dialog-actions">
//                   <Button onClick={handleCloseDialog} color="secondary">
//                     Cancel
//                   </Button>
//                   <Button 
//                     onClick={handleSubmitPackage} 
//                     color="primary" 
//                     variant="contained"
//                     disabled={!packageDetails.packageName || !packageDetails.totalAmount}
//                   >
//                     Create Package
//                   </Button>
//                 </DialogActions>
//               </DialogContent>
//             ))}
//           </Dialog>
//         )}
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default PackagePage;


//code with category card
import React, { useEffect, useRef, useState, useMemo } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  Pagination,
  IconButton,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  CircularProgress,
  Grid,
  Box
} from '@mui/material';
import './PackagePage.css';
import { useMain } from '../../hooks/useMain';

import { MdClear, MdCategory, MdSpa, MdExpandMore, MdExpandLess } from "react-icons/md";
import { GrStar } from 'react-icons/gr';
import SearchImg from '../../../assets/search.svg';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import TextInputs from 'src/components/inputs/TextInputs';

const DurationTypes = [
  { value: 'duration', label: 'Duration (in Months)' },
  { value: 'validTill', label: 'Valid Till Date' }
];

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
];

const PackagePage = () => {
  const { activeBranchId, getAllService, setShowMessage, createPackages, branchData } = useMain();
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [packageDetails, setPackageDetails] = useState({
    packageName: '',
    durationType: '',
    packageDuration: '',
    validTill: '',
    totalAmount: 0,
    taxStatus: 'noGst', // Add taxStatus field
    subtotal: 0
  });
  const [loading, setLoader] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [packageNameError, setPackageNameError] = useState('');
  const [packageDurationError, setPackageDurationError] = useState('');
  const [durationTypeError, setDurationTypeError] = useState('');
  const [validTillError, setValidTillError] = useState('');
  const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

  const taxableValue = useMemo(() => {
    const p = Number(packageDetails.totalAmount) || 0;
    if (!isGstRequired) {
      return p.toFixed(2);
    }
    if (packageDetails.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [packageDetails.totalAmount, packageDetails.taxStatus, isGstRequired]);

  // Extract unique categories
  useEffect(() => {
    if (services.length > 0) {
      const uniqueCategories = [...new Set(services.map(service => service.category))];
      setCategories(uniqueCategories);

      // Initialize expanded state for all categories
      const initialExpanded = {};
      uniqueCategories.forEach(category => {
        initialExpanded[category] = true;
      });
      setExpandedCategories(initialExpanded);
    }
  }, [services]);

  const getAllServicefData = async () => {
    try {
      setPageLoading(true);
      const res = await getAllService(activeBranchId);
      setServices(res?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      getAllServicefData();
    }
    return () => {
      setServices([]);
    };
  }, [activeBranchId]);

  const handleCheckboxChange = (service) => {
    setSelectedServices((prevSelected) => {
      const isSelected = prevSelected.some((item) => item._id === service._id);
      if (isSelected) {
        return prevSelected.filter((item) => item._id !== service._id);
      } else {
        return [...prevSelected, service];
      }
    });
  };

  const handlePackageDetailsChange = (e) => {
    const { name, value } = e.target;

    // Validate package name length
    if (name === 'packageName') {
      if (value.length > 20) {
        setPackageNameError('Package name must be 20 characters or less');
      } else {
        setPackageNameError('');
      }
    }

    let newValue = value;

    if (name === 'packageDuration') {
      // If user clears the field, reset it and remove errors
      if (value === '') {
        setPackageDurationError('');
        setPackageDetails((prev) => ({
          ...prev,
          [name]: '',
        }));
        return;
      }

      // Convert to number
      const duration = Number(value);

      // Prevent decimals and non-numeric input
      if (!Number.isInteger(duration)) {
        setPackageDurationError('Duration must be a whole number');
        return;
      }

      // Validate duration > 0
      if (duration <= 0) {
        setPackageDurationError('Duration must be greater than 0 month');
        return;
      }

      setPackageDurationError('');
      newValue = duration;
    }

    // For totalAmount, update only the field, keep subtotal unchanged
    if (name === 'totalAmount') {
      setPackageDetails((prevDetails) => ({
        ...prevDetails,
        [name]: newValue,
      }));
      return;
    }

    setPackageDetails((prevDetails) => ({
      ...prevDetails,
      [name]: newValue,
    }));
  };

  const handleDurationTypeChange = (e) => {
    const { value } = e.target;
    setPackageDetails((prevDetails) => ({
      ...prevDetails,
      durationType: value,
      packageDuration: value === 'duration' ? prevDetails.packageDuration : '',
      validTill: value === 'validTill' ? prevDetails.validTill : '',
    }));
    setDurationTypeError('');
    setPackageDurationError('');
    setValidTillError('');
  };

  const calculateTotalSelectedPrice = () => {
    return selectedServices.reduce((total, service) => total + (service.price || 0), 0);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
    const subtotal = calculateTotalSelectedPrice();
    setPackageDetails(prev => ({
      ...prev,
      totalAmount: subtotal,
      subtotal: subtotal
    }));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setPackageDetails({
      packageName: '',
      durationType: '',
      packageDuration: '',
      taxStatus: 'noGst', // Reset taxStatus
      validTill: '',
      totalAmount: 0,
      subtotal: 0
    });
    setPackageNameError('');
    setDurationTypeError('');
    setPackageDurationError('');
    setValidTillError('');
  };

  const handleSubmitPackage = async () => {
    const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

    if (isGstRequired && (packageDetails.taxStatus === 'noGst' || !packageDetails.taxStatus)) {
      setShowMessage({ message: 'Tax Status is required when GST number is present', messageType: 'error' });
      return;
    }

    // Validate package name
    if (packageNameError) return;

    // Validate duration type
    if (!packageDetails.durationType) {
      setDurationTypeError('Please select duration type');
      return;
    }

    // Validate duration based on type
    if (packageDetails.durationType === 'duration') {
      if (!packageDetails.packageDuration || packageDetails.packageDuration <= 0) {
        setPackageDurationError('Please enter duration greater than 0 month');
        return;
      }
    } else if (packageDetails.durationType === 'validTill') {
      if (!packageDetails.validTill) {
        setValidTillError('Please select valid till date');
        return;
      }
    }

        const packageData = {
      packageName: packageDetails.packageName,
      price: packageDetails.totalAmount,
      services: selectedServices.map((service) => service._id),
      taxStatus: isGstRequired ? packageDetails.taxStatus : 'noGst',
      taxableValue: taxableValue,
      branchDetails: activeBranchId,
    };

    // Add either duration or validTill based on selection
    if (packageDetails.durationType === 'duration') {
      packageData.packageDuration = packageDetails.packageDuration;
    } else {
      packageData.validTill = packageDetails.validTill;
    }

    try {
      setLoader(true);
      const res = await createPackages(
        JSON.stringify({
          ...packageData,
        }),
      );

      handleCloseDialog();
      if (res?.statusCode === 200) {
        setSelectedServices([]);
        setShowMessage({
          message: res.message || 'Package created successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({ message: res.message || 'Package not created', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Error creating Packages',
        messageType: 'error',
      });
    } finally {
      setLoader(false);
    }
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Enhanced search functionality - search by both service name and category
  const filterServicesBySearch = () => {
    if (!search) return services;

    return services.filter(service => {
      const serviceNameMatch = service.serviceName.toLowerCase().includes(search.toLowerCase());
      const categoryMatch = service.category.toLowerCase().includes(search.toLowerCase());
      return serviceNameMatch || categoryMatch;
    });
  };

  const filteredServices = filterServicesBySearch();

  // Group services by category
  const servicesByCategory = {};
  categories.forEach(category => {
    const categoryServices = filteredServices.filter(service => service.category === category);
    if (categoryServices.length > 0) {
      servicesByCategory[category] = categoryServices;
    }
  });

  // Get visible categories based on pagination
  const visibleCategories = Object.keys(servicesByCategory).slice((page - 1) * limit, page * limit);

  // Calculate pagination count based on categories, not services
  const paginationCount = Math.ceil(Object.keys(servicesByCategory).length / limit);

  const ServiceCard = ({ service, isSelected, onSelect }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const serviceNameRef = useRef(null);

    // Check if text is overflowing
    const isTextOverflowing = () => {
      if (!serviceNameRef.current) return false;
      return serviceNameRef.current.scrollWidth > serviceNameRef.current.clientWidth;
    };

    return (
      <Card
        className={`service-card ${isSelected ? 'selected' : ''}`}
        onClick={() => onSelect(service)}
        onMouseEnter={() => {
          if (isTextOverflowing()) {
            setShowTooltip(true);
          }
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <CardContent className="service-card-content">
          <div className="service-single-row">
            <div className="service-name-container">
              <Typography
                variant="h6"
                className="service-name"
                ref={serviceNameRef}
              >
                {service.serviceName}
              </Typography>
              {showTooltip && isTextOverflowing() && (
                <div className="service-tooltip">
                  {service.serviceName}
                </div>
              )}
            </div>
            <span className="gender-text">
              {service.serviceFor || 'Unisex'}
            </span>
            <span className="price-text">
              ₹{service.price}
            </span>
          </div>
        </CardContent>
      </Card>
    );
  };

  const SelectedServiceCard = ({ service, onRemove }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const serviceNameRef = useRef(null);

    // Check if text is overflowing
    const isTextOverflowing = () => {
      if (!serviceNameRef.current) return false;
      return serviceNameRef.current.scrollWidth > serviceNameRef.current.clientWidth;
    };

    return (
      <Card className="selected-service-card">
        <CardContent>
          <div className="selected-service-header">
            <div className="selected-service-name-container">
              <Typography
                variant="subtitle1"
                className="selected-service-name"
                ref={serviceNameRef}
                onMouseEnter={() => {
                  if (isTextOverflowing()) {
                    setShowTooltip(true);
                  }
                }}
                onMouseLeave={() => setShowTooltip(false)}
              >
                {service.serviceName}
              </Typography>
              {showTooltip && isTextOverflowing() && (
                <div className="selected-service-tooltip">
                  {service.serviceName}
                </div>
              )}
            </div>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(service);
              }}
              className="remove-btn"
            >
              <MdClear />
            </IconButton>
          </div>
        </CardContent>
      </Card>
    );
  };

  if (pageLoading) {
    return (
      <PageContainer title="Package" description="Create service packages">
        <DashboardCard2 title="Create Package">
          <div className="loading-container">
            <ShowLoader />
          </div>
        </DashboardCard2>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Package" description="Create service packages">
      <DashboardCard2 title="Create Package">
        <div className="package-container">
          <div className="services-section">
            <div className="filters-container">
              <div className="search-filter">
                <div className="search-input compact">
                  <img src={SearchImg} alt="Search" />
                  <input
                    type="text"
                    placeholder="Search services or categories..."
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPage(1); // Reset to first page when search changes
                    }}
                  />
                  {search && (
                    <IconButton
                      onClick={() => setSearch('')}
                      size="small"
                    >
                      <MdClear />
                    </IconButton>
                  )}
                </div>

                <FormControl variant="outlined" size="small" className="page-size-filter">
                  <InputLabel>Categories per page</InputLabel>
                  <Select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    style={{ width: '150px', textAlign: 'center' }}
                    label="Categories per page"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                  </Select>
                </FormControl>

                <Button
                  variant="outlined"
                  onClick={() => {
                    setSearch('');
                    setSelectedServices([]);
                    setPage(1);
                  }}
                  className="clear-btn"
                >
                  Clear All
                </Button>
              </div>
            </div>

            <div className="categories-container">
              {visibleCategories.length > 0 ? (
                visibleCategories.map(category => (
                  <div key={category} className="category-section">
                    <div
                      className="category-header"
                      onClick={() => toggleCategory(category)}
                      style={{ backgroundColor: '#6174DD' }}
                    >
                      <Typography variant="h6" className="category-title" style={{ color: 'white' }}>
                        <MdCategory className="category-icon" style={{ color: 'white' }} />
                        Category: {category}
                      </Typography>
                      <IconButton size="small" style={{ color: 'white' }}>
                        {expandedCategories[category] ? <MdExpandLess /> : <MdExpandMore />}
                      </IconButton>
                    </div>

                    {expandedCategories[category] && (
                      <div className="services-grid">
                        {servicesByCategory[category].map((service) => {
                          const isSelected = selectedServices.some(
                            (item) => item._id === service._id
                          );
                          return (
                            <ServiceCard
                              key={service._id}
                              service={service}
                              isSelected={isSelected}
                              onSelect={handleCheckboxChange}
                            />
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="no-services">
                  <MdSpa size={48} />
                  <Typography variant="h6">No services found</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Try adjusting your search
                  </Typography>
                </div>
              )}
            </div>

            {Object.keys(servicesByCategory).length > 0 && (
              <div className="pagination-container">
                <Pagination
                  count={paginationCount}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </div>
            )}
          </div>

          <div className="selection-section">
            <Card className="selection-card">
              <CardContent>
                <Typography variant="h6" className="selection-title">
                  Selected Services
                </Typography>

                {selectedServices.length > 0 ? (
                  <>
                    <div className="selected-services-list">
                      {selectedServices.map((service, index) => (
                        <SelectedServiceCard
                          key={index}
                          service={service}
                          onRemove={handleCheckboxChange}
                        />
                      ))}
                    </div>

                    <div className="selection-summary">
                      <div className="summary-item">
                        <Typography variant="body1">Total Services:</Typography>
                        <Typography variant="body1" className="summary-value">
                          {selectedServices.length}
                        </Typography>
                      </div>
                      <div className="summary-item total">
                        <Typography variant="h6">Total Price:</Typography>
                        <Typography variant="h6" className="summary-value">
                          ₹{calculateTotalSelectedPrice()}
                        </Typography>
                      </div>

                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleOpenDialog}
                        className="create-package-btn"
                      >
                        Create Package
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="empty-selection">
                    <MdSpa size={32} />
                    <Typography variant="body2" color="textSecondary">
                      Select services from the list to create a package
                    </Typography>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        </div>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="sm"
          fullWidth
        >
          {loading ? (
            <DialogContent>
              <div className="dialog-loading">
                <CircularProgress size={40} />
                <Typography variant="h6" style={{ marginTop: '16px' }}>
                  Creating Package...
                </Typography>
              </div>
            </DialogContent>
          ) : (
            <>
              <DialogTitle className="dialog-title">
                <Typography variant="h5">Create New Package</Typography>
              </DialogTitle>

              <DialogContent className="dialog-content">
                <div className="package-form">
                  <div className="form-field-with-label">
                    <Typography variant="body2" className="field-label" style={{ color: '#000', fontSize: '16px', fontWeight: '500' }}>
                      Package Name <GrStar style={{ color: '#FF0000', fontSize: '10px' }} />
                    </Typography>
                    <TextField
                      autoFocus
                      margin="dense"
                      type="text"
                      fullWidth
                      variant="outlined"
                      name="packageName"
                      placeholder="e.g., Premium Facial Package"
                      value={packageDetails.packageName}
                      onChange={handlePackageDetailsChange}
                      required
                      error={!!packageNameError}
                      helperText={packageNameError}
                    />
                  </div>

                  {/* Duration Type and Duration/Valid Till fields side by side */}
                  <Box sx={{ marginTop: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth margin="dense" error={!!durationTypeError}>
                          <InputLabel>Duration Type</InputLabel>
                          <Select
                            value={packageDetails.durationType}
                            onChange={handleDurationTypeChange}
                            label="Duration Type"
                            name="durationType"
                          >
                            <MenuItem value="" disabled>
                              Select Duration Type
                            </MenuItem>
                            {DurationTypes.map((type) => (
                              <MenuItem key={type.value} value={type.value}>
                                {type.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {durationTypeError && (
                            <Typography variant="caption" color="error">
                              {durationTypeError}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        {packageDetails.durationType === 'duration' && (
                          <TextField
                            margin="dense"
                            label="Duration (months)"
                            type="number"
                            fullWidth
                            variant="outlined"
                            name="packageDuration"
                            placeholder="Enter duration in months"
                            value={packageDetails.packageDuration}
                            onChange={handlePackageDetailsChange}
                            error={!!packageDurationError}
                            helperText={packageDurationError || ''}
                            inputProps={{ min: 1, step: 1 }}
                          />
                        )}
                        {packageDetails.durationType === 'validTill' && (
                          <TextField
                            margin="dense"
                            label="Valid Till Date"
                            type="date"
                            fullWidth
                            variant="outlined"
                            name="validTill"
                            value={packageDetails.validTill}
                            onChange={handlePackageDetailsChange}
                            error={!!validTillError}
                            helperText={validTillError || ''}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Box>

                  <div className="services-table">
                    <Typography variant="subtitle1" className="table-title">
                      Included Services ({selectedServices.length})
                    </Typography>
                    <div className="table-container">
                      {selectedServices.map((service, index) => (
                        <div key={index} className="service-row">
                          <div className="service-name">
                            <MdSpa className="service-icon" />
                            <span>{service.serviceName}</span>
                          </div>
                          <div className="service-price">₹{service.price}</div>
                        </div>
                      ))}
                    </div>

                    <div className="table-footer">
                      <div className="total-row">
                        <span>Subtotal:</span>
                        <span>₹{packageDetails.subtotal}</span>
                      </div>
                    </div>
                  </div>

                  <Box sx={{ marginTop: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={isGstRequired ? 6 : 12}>
                          <FormControl fullWidth>
                            <label style={{
                              fontSize: "15px",
                              fontWeight: 600,
                              marginBottom: "8px",
                              display: "inline-block",
                              color: "#212529"
                            }}>Package Amount
                              <GrStar style={{ color: '#FF0000', fontSize: '10px', marginLeft: '4px' }} />
                            </label>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                height: "57px",
                                transition: 'border-color 0.2s ease-in-out',
                                '&:hover': {
                                  borderColor: '#6174DD',
                                },
                              }}
                            >
                              <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                              <input
                                name="totalAmount"
                                placeholder="0"
                                value={packageDetails.totalAmount}
                                onChange={handlePackageDetailsChange}
                                type="number"
                                min="0"
                                style={{
                                  border: 'none',
                                  outline: 'none',
                                  flex: 1,
                                  padding: '12px 0px',
                                  fontSize: '16px',
                                  background: 'transparent',
                                  width: '100%'
                                }}
                              />
                              {isGstRequired && (
                                <Select
                                  name="taxStatus"
                                  value={packageDetails.taxStatus || 'noGst'}
                                  onChange={handlePackageDetailsChange}
                                  displayEmpty
                                  inputProps={{ 'aria-label': 'Without label' }}
                                  sx={{
                                    background: '#F0F0F0',
                                    border: 'none',
                                    height: '100%',
                                    borderTopLeftRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderTopRightRadius: '3px',
                                    borderBottomRightRadius: '3px',
                                    '& .MuiSelect-select': {
                                      padding: '8px 16px',
                                      paddingRight: '24px !important',
                                      height: '100% !important',
                                      display: 'flex',
                                      alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none'
                                    },
                                    '&:hover': {
                                      background: '#e0e0e0',
                                    },
                                    '&.Mui-focused': {
                                      background: '#e0e0e0',
                                    },
                                    borderLeft: '1px solid #ced4da'
                                  }}
                                >
                                  {taxStatusOptions.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              )}
                            </Box>
                            {isGstRequired && (
                              <Box sx={{
                                p: '8px 12px',
                                backgroundColor: '#e9ecef',
                                border: '1px solid #ced4da',
                                borderTop: 'none',
                                borderRadius: '0 0 4px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}>
                                <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                              </Box>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Box>
                </div>

                <DialogActions className="dialog-actions">
                  <Button onClick={handleCloseDialog} color="secondary">
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmitPackage}
                    color="primary"
                    variant="contained"
                    disabled={!packageDetails.packageName || !packageDetails.totalAmount || !!packageNameError || !packageDetails.durationType}
                  >
                    Create Package
                  </Button>
                </DialogActions>
              </DialogContent>
            </>
          )}
        </Dialog>
      </DashboardCard2>
    </PageContainer>
  );
};

export default PackagePage;